import { usePrefersReducedMotion } from '@/hooks/useMediaQuery'
import { cn } from '@/utils/cn'

/**
 * Router-level `Suspense` fallback — the brief window while a lazy route's
 * JS chunk downloads/parses, before the page component itself even mounts.
 * Deliberately NOT content-shaped (no `PageSkeleton`-style fake dashboard):
 * almost every page renders its own correctly-shaped skeleton once mounted
 * (`TableSkeleton`, `DetailSkeleton`, …) while its data loads, so a
 * content-shaped fallback here just means two different-looking "loading"
 * layouts flash in quick succession — barely visible on a fast desktop
 * (chunk resolves before the fallback even paints) but a real, jarring
 * shape-swap on a slower mobile CPU/connection where the fallback is up
 * long enough to register. This is that "extra loading / jerk" mobile-only
 * complaint — see docs/SYSTEM_OVERVIEW.md §17 and pmms-frontend rules.
 */
export function RouteLoadingBar() {
  const reducedMotion = usePrefersReducedMotion()

  return (
    <div
      className="pointer-events-none fixed inset-x-0 top-0 z-[60] h-[3px] overflow-hidden bg-primary/15"
      role="status"
      aria-busy="true"
      aria-label="Loading page"
    >
      <div
        className={cn(
          'h-full w-1/3 bg-primary',
          reducedMotion ? 'opacity-70' : 'animate-route-loading-bar',
        )}
      />
    </div>
  )
}
